import { Component } from '@angular/core';


@Component({
  selector: 'lib-data-access',
  imports: [],
  templateUrl: './data-access.component.html',
  styleUrl: './data-access.component.css',
  standalone: true,
})
export class DataAccessComponent {}
